export default function Problem() {
  return (
    <section id="problema" className="bg-[#0a0a0a] py-20 md:py-28 px-6">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-white leading-tight mb-6">
          Si no mides tus números,{' '}
          <span className="text-[#FF6B35]">tienes un pasatiempo caro.</span>
        </h2>
        <div className="w-24 h-1 bg-gradient-to-r from-[#FF6B35] to-transparent mx-auto mb-8 rounded-full"></div>
        <p className="text-gray-400 text-lg leading-relaxed">
          Si sigues usando <strong className="text-[#00FF88]">Excels complicados</strong>, dejas plata en la mesa. Las{' '}
          <strong className="text-[#FF6B35]">fugas de dinero</strong> y los quiebres de stock matan tu rentabilidad.
          Este ecosistema es para que dejes las excusas y operes como un{' '}
          <strong className="text-white">estratega real</strong>.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-12">
          {[
            { icon: 'ri-close-circle-line', text: 'Ventas perdidas por quiebre de stock' },
            { icon: 'ri-money-dollar-circle-line', text: 'Fugas de dinero invisibles cada mes' },
            { icon: 'ri-bar-chart-line', text: 'Sin visibilidad de tus márgenes reales' },
          ].map((item, i) => (
            <div
              key={i}
              className="bg-[#141414] border border-white/5 rounded-xl p-5 flex flex-col items-center gap-3"
            >
              <div className="w-10 h-10 flex items-center justify-center">
                <i className={`${item.icon} text-2xl text-gray-400`}></i>
              </div>
              <p className="text-gray-300 text-sm text-center">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
